export var DealPriceType;
(function (DealPriceType) {
    DealPriceType["FITTED"] = "Fitted";
    DealPriceType["PRIMARY"] = "RDP";
    DealPriceType["SECONDARY"] = "MLP";
    DealPriceType["VEHICLE_TOTAL"] = "TotalBalance";
    DealPriceType["FINAL_PRICE"] = "FinalPrice";
})(DealPriceType || (DealPriceType = {}));
//# sourceMappingURL=DealPriceType.js.map